import React, { Component } from "react";
import { connect } from "react-redux";

import ChainGameBoard from "../../components/ChainReactionGame/ChainGameBoard";
import { setGameBetUnlock, setGameFocusLinkIndex, addGamePoints, reduceGamePoints, setGameBet, setGameWonStatus, setGameLostStatus, resetGameStatus, setGameDataIndex, setGameRevealAllAnswersStatus, GAME_STATUS_REVEAL_ALL_ANSWERS, GAME_STATUS_HINT_CLICK, GAME_STATUS_AWARD_REWARD, setGamePoints, setGameStartStatus, setGameReplayStatus, GAME_STATUS_START, GAME_STATUS_WON, GAME_STATUS_LOST, setGameCorrectAnswerStatus, setGameIncorrectAnswerStatus, GAME_STATUS_CORRECT_ANSWER, GAME_STATUS_INCORRECT_ANSWER, GAME_STATUS_REVEAL_ALL_ANSWERS_CLICK, setGameQuitStatus, GAME_STATUS_QUIT, setIsAllowHintOnFocusLink } from "../../actions/game";
import { playSound, stopSound } from "../../utils/audio-helper";

class GameContainer extends Component {
  constructor(props) {
    super(props);
    const self = this;

    self.state = {
      gameBoardContent: [],
      gameBoardContentHasUpdated: false,
      answers: [],
      numUnsolvedLinks: null,
      keyCode: null,
      typingInactivity: false,
      focusedLinkValue: '',
      revealAllAnswers: false,
      revealAllAnswersIndex: null,
      endGame: false,
      updateGameBoardContent: false,
      revealLinkValue: null,
      disableLink: null
    };

    this.handleLinkChange = this.handleLinkChange.bind(this);
    this.handleLinkFocus = this.handleLinkFocus.bind(this);
    this.handleLinkKeyPress = this.handleLinkKeyPress.bind(this);
    // this.handleLinkBlur = this.handleLinkBlur.bind(this);

    this.typingInactivityTimer = null;
  }

  delay(callback, delay) {
    return window.setTimeout(()=>{
      callback();
    }, delay);
  }

  handleLinkKeyPress(evt) {
    // console.log('this.handleLinkKeyPress', this.typingInactivityTimer);

    if (!this.typingInactivityTimer) {
      // this.setInactivityTimer();
    }
  }
  
  handleLinkChange(linkIndex, value) {
    // console.log('handleLinkChange', linkIndex, value);

    if (this.answerFound(linkIndex, value)) {
      this.setPointsFromBet();
      this.clearInactivityTimer();
      this.revealLinkAnswer(this.props.focusLinkIndex, true);
      this.disableAllLinks();
      this.props.setGameFocusLinkIndex(null);
      this.props.setGameCorrectAnswerStatus();
      return;
    } 

    this.setState({focusedLinkValue: value});
  }

  handleLinkFocus(currentIndex) {
    const {
      betLocked,
      setGameFocusLinkIndex
    } = this.props;

    if (!betLocked) {
      setGameFocusLinkIndex(currentIndex);
    }
  }

  handleWrongAnswerInput() {
    const deductPoints = true;

    //reveal first char of next link and deduct points
    this.props.betLocked && this.revealNextCharOfLink(this.props.focusLinkIndex, true);
    this.setPointsFromBet(deductPoints);
    
    //disable game board and reset for next word chain
    this.disableAllLinks();
    this.setState({
      keyCode: null, 
      focusedLinkValue: '', 
      updateGameBoardContent: true
    });
    this.props.setGameFocusLinkIndex(null);
    // this.clearInactivityTimer();

    playSound(this.props.sounds, 'incorrect');

    this.delay(()=>{
      this.setState({updateGameBoardContent: true});
    }, 1000); //update game board to clear incorrect status
  }

  setPointsFromBet(deduct=false) {
    const {
      bet,
      betLocked,
      addGamePoints,
      reduceGamePoints,
      setGameBet,
      setGameBetUnlock
    } = this.props;

    if (betLocked) {
      ( deduct ? reduceGamePoints(bet) : addGamePoints(bet));

      //clearBet
      setGameBet(0);
      setGameBetUnlock();
    }
  }

  answerFound(linkIndex, value) {
    // console.log('answerFount', linkIndex, value);
    const upperCaseValue = value.toUpperCase(),
      correctAnswer = this.state.gameBoardContent[linkIndex].answer.toUpperCase(),
      displayValue = this.state.gameBoardContent[linkIndex].value.toUpperCase(),
      altWord = this.props.alternateWords[correctAnswer],
      inclusionAltWordList = altWord && altWord.filter(alt=>alt.toUpperCase()!==displayValue && alt.toUpperCase()!==correctAnswer);

    // console.log('altWord', altWord, upperCaseValue);
    return (correctAnswer === upperCaseValue || (altWord && inclusionAltWordList.some(alt=>alt.toUpperCase()===upperCaseValue)))
  }

  // for updating chain game board properties
  revealLinkAnswer(index, statusCorrect=false) {
    const status = statusCorrect?'STATUS_CORRECT':'';
    this.setState({revealLinkValue:{type:'REVEAL_LINK_ANSWER', index, status}});
  }

  revealFirstCharOfNextLink() {
    this.setState({revealLinkValue:{type:'REVEAL_LINK_FIRST_CHAR'}});
  }

  revealNextCharOfLink(index, statusIncorrect=false) {
    const status = statusIncorrect?'STATUS_INCORRECT':'';
    this.setState({revealLinkValue:{type:'REVEAL_LINK_NEXT_CHAR', index, status}})
  }

  disableAllLinks() {
    this.setState({disableLink:{type:'DISABLE_LINK_ALL'}});
  }

  disableUnfocusedLinks(index) {
    console.log('disableUnfocusedLinks');
    this.setState({disableLink:{type:'DISABLE_LINK_UNFOCUSED',index}});
  }

  setInactivityTimer(delay=6000) {
    const self = this;

    self.typingInactivityTimer = window.setTimeout(()=>{
      self.setState({typingInactivity: true})
    }, delay);
  }

  clearInactivityTimer() {
    window.clearTimeout(this.typingInactivityTimer);
    this.setState({typingInactivity: false})
  }

  setNumUnsolvedLinks() {
    const numUnsolvedLinks = this.state.gameBoardContent.reduce((prevVal, item)=>item.answer===item.value?prevVal:prevVal+1, 0);
    this.setState({numUnsolvedLinks});
  }

  setGameResultStatus(delay=2000) {

    //advance game data index for next game
    this.props.setGameDataIndex((this.props.gameDataIndex + 1) >= this.props.gameData.length ? 0 : this.props.gameDataIndex+1)

    this.delay(()=>{
      if (this.state.numUnsolvedLinks === 0 && !this.state.revealAllAnswers) {
        this.props.setGameWonStatus();
      } else {
        this.props.setGameLostStatus();
      }
    }, delay);
  }

  revealWCAnswer(linkIndex, delay=0) {
    const self = this;
// console.log('revealWCAnswer', linkIndex, delay);
      window.setTimeout(()=>{
        self.revealLinkAnswer(linkIndex);
        // self.disableAllLinks();
        // self.setNextRevealWCAnswerIndex();
      }, delay);
  }

  setNextRevealWCAnswerIndex() {
    const gameBoardContent = this.state.gameBoardContent,
      revealAllAnswersIndex = gameBoardContent.findIndex(element => (element.value.toUpperCase() !== element.answer.toUpperCase()));

    this.setState({revealAllAnswersIndex});
  }

  setEndGameStateWithDelay() {
    this.setState({endGame: true});
  }

  setGameBoard(gameBoardContent) {
    this.setState({gameBoardContent, gameBoardContentHasUpdated:true});
  }

  componentDidMount() {
    const self = this;

    this.props.setGamePoints(200); // reset game points
    this.props.setGameStartStatus();

    window.addEventListener('keydown',(evt)=>{
      // console.log('keypress', evt, evt.code);
      self.setState({keyCode:evt.code || evt.key});
    })
  }

  componentDidUpdate(prevProps, prevState) {

    //After game board has been updated
    if (this.state.gameBoardContentHasUpdated && prevState.gameBoardContentHasUpdated!==this.state.gameBoardContentHasUpdated) {

      //reset states
      this.setState({
        gameBoardContentHasUpdated: false, 
        updateGameBoardContent: false, 
        revealLinkValue: null, 
      });
      this.setNumUnsolvedLinks();

      //if reveal answer set next answer to be revealed
      if (this.state.revealAllAnswers) {
        this.setNextRevealWCAnswerIndex();
      }

      //check if board should be updated
      if (this.props.focusLinkIndex !== null) {
        this.handleLinkChange(this.props.focusLinkIndex, this.state.gameBoardContent[this.props.focusLinkIndex].value);
        this.props.setIsAllowHintOnFocusLink(!this.state.gameBoardContent[this.props.focusLinkIndex].lastChar);
      }
    }

    //enable game board after betting
    if (
      (this.props.bet > 0 && this.props.bet !== prevProps.bet)
      ) {
      this.setState({
        updateGameBoardContent: true, 
        disableLink: null //enable playable word chain
      });
    }

    //update game board if value needs to been updated on word chains
    if (
      (this.state.revealLinkValue && this.state.revealLinkValue !== prevState.revealLinkValue)
      ) {
      this.setState({updateGameBoardContent: true});
    }

    // Answered Correctly, reveal first char of next word chain
    if (!this.state.revealAllAnswers &&
      (this.state.numUnsolvedLinks > 0 && prevState.numUnsolvedLinks > this.state.numUnsolvedLinks)
      ) {
        
      this.delay(()=>{
        this.revealFirstCharOfNextLink();
        this.props.setGameFocusLinkIndex(null);
      }, 1000);
    }

    // Chain Completed or show result screen
    if (
        (!this.state.revealAllAnswers && this.state.numUnsolvedLinks === 0 && prevState.numUnsolvedLinks !== this.state.numUnsolvedLinks) || 
        (this.state.endGame && prevState.endGame !== this.state.endGame) ||
        (this.props.gameStatus === GAME_STATUS_QUIT && this.props.gameStatus !== prevProps.gameStatus)
    ) {
      const delay = (this.props.gameStatus === GAME_STATUS_QUIT && 1) || 2000;
      this.setGameResultStatus(delay);
      stopSound(this.props.sounds, 'music');
    }

    // Bet has been placed, enable game board
    if (this.props.betLocked && this.props.focusLinkIndex!==null && prevProps.betLocked===false) {
      this.disableUnfocusedLinks(this.props.focusLinkIndex);
      this.props.setIsAllowHintOnFocusLink(!this.state.gameBoardContent[this.props.focusLinkIndex].lastChar);
      this.setState({updateGameBoardContent: true});
    }

    // if Enter key is pressed, accept current answer
    if (
      (this.state.keyCode==='Go' && this.state.keyCode !== prevState.keyCode) ||
      (this.state.keyCode==='Enter' && this.state.keyCode !== prevState.keyCode) ||
      (this.state.typingInactivity && this.state.typingInactivity !== prevState.typingInactivity) ||
      (this.state.focusedLinkValue.length > 11 && this.state.focusedLinkValue !== prevState.focusedLinkValue)
    ) {
      this.handleWrongAnswerInput();
    }

    // initiate reveal all answers
    if (
      // (this.state.keyCode==='Space' && this.state.keyCode !== prevState.keyCode) || // Test Reveal All Answers
      (this.props.gameStatus===GAME_STATUS_REVEAL_ALL_ANSWERS && prevProps.gameStatus !== this.props.gameStatus)
    ) {
      this.disableAllLinks();
      this.setState({
        revealAllAnswers: true,
        updateGameBoardContent: true
      })
    }

    // reward hint click video watch
    if (this.props.gameStatus === GAME_STATUS_AWARD_REWARD && prevProps.gameStatus === GAME_STATUS_HINT_CLICK) {
      this.revealNextCharOfLink(this.props.focusLinkIndex);
    }

    // reward reveal answer video watch
    if (this.props.gameStatus === GAME_STATUS_AWARD_REWARD && prevProps.gameStatus === GAME_STATUS_REVEAL_ALL_ANSWERS_CLICK) {
      this.props.setGameRevealAllAnswersStatus();
    }

    // prep next answer to be revealed for reveal all answers
    if (
      (this.state.revealAllAnswers && prevState.revealAllAnswers !== this.state.revealAllAnswers)
      ) {
        this.setNextRevealWCAnswerIndex();
        stopSound(this.props.sounds, 'music');
    } 

    //Reveal answer of the current selected index
    if (
      (this.state.revealAllAnswersIndex && prevState.revealAllAnswersIndex !== this.state.revealAllAnswersIndex)
      ) {
      this.revealWCAnswer(this.state.revealAllAnswersIndex, 1800);
    }

    //End game
    if ((this.state.revealAllAnswersIndex === -1 && prevState.revealAllAnswersIndex !== this.state.revealAllAnswersIndex)
    ) {
      this.setEndGameStateWithDelay();
    }

    // Set replay status
    if (this.props.gameStatus === GAME_STATUS_START && (prevProps.gameStatus === GAME_STATUS_WON || prevProps.gameStatus === GAME_STATUS_LOST)) {
      this.props.setGameReplayStatus();
    }

    // reset game status on correct and incorrect answers
    if ((this.props.gameStatus === GAME_STATUS_CORRECT_ANSWER || this.props.gameStatus === GAME_STATUS_INCORRECT_ANSWER) && prevProps.gameStatus === this.props.gameStatus) {
      this.props.resetGameStatus();
    }

    //Go to results page depending on game status
    if ((this.props.gameStatus === GAME_STATUS_WON || this.props.gameStatus === GAME_STATUS_LOST) && prevProps.gameStatus !== this.props.gameStatus) {
      this.props.transitionOut()
    }
  }

  render() {
    return (
      <ChainGameBoard
        update={this.state.updateGameBoardContent}
        answers={this.props.gameData[this.props.gameDataIndex]}
        updateParentGameBoardContent={this.setGameBoard.bind(this)}
        gameBoard={this.state.gameBoardContent}
        handleLinkChange={this.handleLinkChange}
        handleLinkFocus={this.handleLinkFocus}
        handleLinkKeyPress={this.handleLinkKeyPress}
        selectLinkIndex={this.props.focusLinkIndex}
        disableLink={this.state.disableLink}
        revealLinkValue={this.state.revealLinkValue}
        betLocked={this.props.betLocked}
        bet={this.props.bet}
        sounds={this.props.sounds}
      />
    );
  }
}

const mapStateToProps = state => ({
  sounds: state.audio.sounds,
  alternateWords: state.alternateWords,
  focusLinkIndex: state.game.focusLinkIndex,
  gameData: state.game.data,
  gameDataIndex: state.game.dataIndex,
  betLocked: state.game.betLocked,
  points: state.game.points,
  bet: state.game.bet,
  gameStatus: state.game.status
});

const mapDispatchToProps = dispatch => ({
  setGameFocusLinkIndex: data=>{
    dispatch(setGameFocusLinkIndex(data));
  },
  setIsAllowHintOnFocusLink: data=>{
    dispatch(setIsAllowHintOnFocusLink(data));
  },
  setGameBet: data=>{
    dispatch(setGameBet(data));
  },
  setGameBetUnlock: ()=>{
    dispatch(setGameBetUnlock());
  },
  addGamePoints: data=>{
    dispatch(addGamePoints(data));
  },
  reduceGamePoints: data=>{
    dispatch(reduceGamePoints(data));
  },
  setGamePoints: data => {
    dispatch(setGamePoints(data));
  },
  setGameWonStatus: ()=>{
    dispatch(setGameWonStatus());
  },
  setGameLostStatus: ()=>{
    dispatch(setGameLostStatus());
  },
  setGameQuitStatus: ()=>{
    dispatch(setGameQuitStatus());
  },
  setGameStartStatus: ()=>{
    dispatch(setGameStartStatus());
  },
  setGameReplayStatus: ()=>{
    dispatch(setGameReplayStatus());
  },
  setGameCorrectAnswerStatus: ()=>{
    dispatch(setGameCorrectAnswerStatus());
  },
  setGameIncorrectAnswerStatus: ()=>{
    dispatch(setGameIncorrectAnswerStatus());
  },
  setGameRevealAllAnswersStatus: ()=>{
    dispatch(setGameRevealAllAnswersStatus());
  },
  resetGameStatus: data=>{
    dispatch(resetGameStatus(data));
  },
  setGameDataIndex: data=> {
    dispatch(setGameDataIndex(data))
  }
});

GameContainer.propTypes = {
  // quizQuestions: PropTypes.array.isRequired,
  // showAnswer: PropTypes.bool.isRequired,
  // index: PropTypes.number.isRequired,
  // onAnswerSelected: PropTypes.func.isRequired
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GameContainer);



// WEBPACK FOOTER //
// ./src/containers/ChainReactionGame/GameContainer.js